import styled from "styled-components";
import { theme } from "styles/theme";

export const LoadingUserLayoutStyle = styled.div`
  .loading-bg {
    width: "100%";
    height: calc(100vh - 180px);
    background-color: ${theme.backgroundColors.primary};
  }
`;
